//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

export default {
  CHANGE_SUMMARY_TREND_GRAPH_SELECTED_VALUE: 'CHANGE_SUMMARY_TREND_GRAPH_SELECTED_VALUE',
  CHANGE_SUMMARY_REFERRAL_GRAPH_SELECTED_VALUE: 'CHANGE_SUMMARY_REFERRAL_GRAPH_SELECTED_VALUE',
};
